import type {SortBy} from './types';

// Takes a sort parameter from the URL and converts it into a "sortBy"
// array that's expected from react-table.
//
// e.g. turns `-age` into [{id: 'age', desc: true}]
export function convertUrlSortParamToTableSortBy(sortString: string): SortBy[] {
    const isDescending = sortString.charAt(0) === '-';

    return [
        {
            id: isDescending ? sortString.slice(1) : sortString,
            desc: isDescending,
        },
    ];
}

// The reverse of the above function - takes a sortBy object
// and turns it into a string expected by our url sort schema
//
// e.g. turns {id: 'createdTime', desc: true} into `-createdTime`
export function convertSortByToUrlSortParam(sortBy: SortBy[]): string | null | undefined {
    // Currently just getting the first sort param in the array
    const firstSortBy = sortBy[0];

    // In the case of the sort being removed, just return null
    if (!firstSortBy) {
        return null;
    }

    return firstSortBy.desc ? `-${firstSortBy.id}` : firstSortBy.id;
}

type Row = {
    values: {
        [key: string]: string | null | undefined | number;
    };
};

export function caseInsensitiveCompare(row1: Row, row2: Row, columnName: string): -1 | 0 | 1 {
    const rowOneValue = nonEmptyToString(row1.values[columnName]);
    const rowTwoValue = nonEmptyToString(row2.values[columnName]);

    // Missing values should be at the end of the list
    if (rowOneValue === null && rowTwoValue === null) {
        return 0;
    } else if (rowOneValue === null) {
        return 1;
    } else if (rowTwoValue === null) {
        return -1;
    }

    const result = rowOneValue.localeCompare(rowTwoValue, undefined, {
        numeric: true,
    });

    if (result > 0) {
        return 1;
    } else if (result < 0) {
        return -1;
    } else {
        return 0;
    }
}

function nonEmptyToString(value: string | null | undefined | number): string | null {
    return value != null && value !== '' ? value.toString() : null;
}
